import React from 'react';

function Deck({ children }) {
  return <div className="deck-container">{children}</div>;
}

export default Deck;
